import utils from 'utils';

import {useContext} from 'react';
import appContext from "@/appContext.tsx";

// fixme! dehardcode
export const FooterMenu = () => {
    const {currentUser} = useContext(appContext).userContext;

    const data = {
        social: {
            facebook: 'https://www.facebook.com/%C4%8CEMAT-SK-111386955688035/',
            instagram: 'https://www.instagram.com/cemat_trading/',
            linkedin: 'https://www.linkedin.com/company/2758499',
            youtube: 'https://www.youtube.com/user/cemattrading',
        },
    };

    return <div className={cmpClass}>
        <div className={classMap.container}>
            <div className={classMap.box}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Informácie</div>
                    <a href="/wiki/o-nas" target="_blank">O nás</a>
                    <a href="/wiki/montaz-a-lisovani-pneumatik" target="_blank">Montáž a lisovanie pneumatík</a>
                    <a href="/wiki/vseobecne-obchodni-podminky" target="_blank">Všeobecné obchodné podmienky</a>
                    <a href="/wiki/zpracovani-osobnich-udaju" target="_blank">Spracovanie osobných údajov</a>
                    {/*<a href="/wiki/reklamacni-rad">Reklamačný poriadok</a>*/}
                </div>
            </div>
            <div className={classMap.box}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Kontakty</div>
                    <a href="/wiki/obchodni-oddeleni" target="_blank">Obchodné oddelenie</a>
                    {
                        !!currentUser.id && <a href="/machine-request" target="_blank">Kontaktný formulár - dopyt</a>
                    }
                    <br/>
                    <a href="tel:+421905333654" target="_blank">tel.: 421 905 333 654</a>
                    <a href="mailto:cemat@cemat.sk" target="_blank">e-mail: cemat@cemat.sk</a>
                </div>
            </div>
            <div className={classMap.box + ' ' + classMap.boxNoMobile}>
                <div className={classMap.list}>
                    <div className={classMap.title}>Adresa</div>
                    <a href="https://maps.app.goo.gl/EjC4eQ5EdjKcXVKe9" target="_blank">
                        ČEMAT, s.r.o.<br/>
                        Československej armády 12110/3G<br/>
                        036 01 Martin<br/>
                        Slovenská republika<br/>
                    </a>
                </div>
                <div className={classMap.social}>
                    <a href={data.social.facebook} className="iconfab-facebook" target="_blank"></a>
                    <a href={data.social.instagram} className="iconfab-instagram" target="_blank"></a>
                    <a href={data.social.linkedin} className="iconfab-linkedin" target="_blank"></a>
                    <a href={data.social.youtube} className="iconfab-youtube" target="_blank"></a>
                </div>
            </div>
            <div className={classMap.box + ' ' + classMap.boxMobile}>
                <div className={classMap.social}>
                    <a href={data.social.facebook} className="iconfab-facebook" target="_blank"></a>
                    <a href={data.social.instagram} className="iconfab-instagram" target="_blank"></a>
                    <a href={data.social.linkedin} className="iconfab-linkedin" target="_blank"></a>
                    <a href={data.social.youtube} className="iconfab-youtube" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>;
};

const cmpClass = 'footer-menu';
const classMap = utils.generateClassMap(cmpClass, {
    box: 'box',
    boxMobile: 'box--mobile',
    boxNoMobile: 'box--no-mobile',
    container: 'container container',
    list: 'list',
    menu: 'menu',
    social: 'social',
    title: 'title',
});
